import * as detailsActions from './actions';
import detailsEpics from './epics';
import reducer from './reducers';
import * as detailsSelectors from './selectors';
import * as detailsTypes from './types';

export { detailsActions, detailsEpics, detailsSelectors, detailsTypes };

export default reducer;
